import { useCallback, useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';

function needsCompactNavigation(row, nav) {
  const brand = row.querySelector('.hbk-brand');
  const cta = row.querySelector('.hbk-header-cta');
  if (!brand || !cta) return false;
  const style = getComputedStyle(row);
  const available = row.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight);
  const needed = brand.getBoundingClientRect().width + cta.getBoundingClientRect().width + nav.scrollWidth + 3 * parseFloat(style.gap);
  return window.matchMedia('(min-width: 1440px)').matches && needed > available;
}

export function useHeaderNavigation() {
  const [open, setOpen] = useState(false);
  const [forceMenu, setForceMenu] = useState(false);
  const rowRef = useRef(null);
  const navRef = useRef(null);
  const toggle = useCallback(() => setOpen((value) => !value), []);
  const close = useCallback(() => setOpen(false), []);
  const location = useLocation();
  useEffect(() => { close(); }, [location.pathname, location.hash, close]);
  useEffect(() => {
    let active = true;
    const measure = () => {
      if (!active || !rowRef.current || !navRef.current) return;
      const compact = needsCompactNavigation(rowRef.current, navRef.current);
      setForceMenu(compact);
      if (!compact && window.matchMedia('(min-width: 1440px)').matches) close();
    };
    const observer = new ResizeObserver(measure);
    observer.observe(rowRef.current);
    observer.observe(navRef.current);
    window.addEventListener('resize', measure);
    document.fonts?.ready.then(measure);
    measure();
    return () => { active = false; observer.disconnect(); window.removeEventListener('resize', measure); };
  }, [close]);
  useEffect(() => {
    if (!open) return undefined;
    const onKeyDown = (event) => {
      if (event.key !== 'Escape') return;
      close();
      document.getElementById('hbk-menu-toggle')?.focus();
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [open, close]);
  return { open, forceMenu, rowRef, navRef, toggle, close, location };
}